<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

import AppContent from "@/components/AppContent.vue"
import AppShell from "@/components/AppShell.vue"
import AppSidebar from "@/components/AppSidebar.vue"
import AppSidebarHeader from "@/components/AppSidebarHeader.vue"
import ManagerSidebar from "@/components/ManagerSidebar.vue"
import type { BreadcrumbItemType } from "@/types"

interface Props {
  breadcrumbs?: BreadcrumbItemType[]
}

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
})

const page = usePage()

const layout = computed(() => {
  const userMode = page.props.auth.ui_mode
  return userMode === "manager" ? ManagerSidebar : AppSidebar
})
</script>

<template>
  <AppShell variant="sidebar">
    <component :is="layout" />
    <AppContent variant="sidebar" class="max-w-240 min-w-200 overflow-x-hidden">
      <AppSidebarHeader :breadcrumbs="breadcrumbs" />
      <slot />
    </AppContent>
  </AppShell>
</template>
